<template>
  <main class="policy">
    <header-title :headerTitle="headerTitle" />
    <section class="policyInfo" data-aos="fade-left">
      <b-container fluid>
        <div class="wrap">
					<div v-html="content"></div>
        </div>
      </b-container>
    </section>
    <background-image />
  </main>
</template>

<script>
  import headerTitle from "./common/header-title";
  import backgroundImage from "./common/background-image";

  export default {
    name: "policy-data",
    components: {
      headerTitle,
      backgroundImage,
    },
    data: () => ({
      headerTitle: "Политика обработки персональных данных",
      policyData: [
        {
          title: "Общие положения",
          text:
            "Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных Балтик Шиппинг (далее – Оператор). Политикой.",
          list: [
            "Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.",
            "Настоящая политика Оператора в отношении обработки персональных данных (далее – Политика) применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта http://baltic-shipping.com.",
          ],
        },
        {
          title: "Основные понятия, используемые в Политике",
          text:
            "Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных Балтик Шиппинг (далее – Оператор). Политикой.",
          list: [
            "Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники;",
            "Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных);",
            "Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу http://baltic-shipping.com;",
            "Информационная система персональных данных — совокупность содержащихся в базах данных персональных данных, и обеспечивающих их обработку информационных технологий и технических средств;",
            "Обезличивание персональных данных — действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю или иному субъекту персональных данных;",
            "Обработка персональных данных – любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных;",
            "Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными;",
            "Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта http://baltic-shipping.com;",
            "Пользователь – любой посетитель веб-сайта http://baltic-shipping.com;",
            "Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц;",
            "Распространение персональных данных – любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом;",
            "Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу;",
            "Уничтожение персональных данных – любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и (или) результате которых уничтожаются материальные носители персональных данных.",
          ],
        },
      ],
    }),

    computed: {
      pageData() {
        return this.$store.getters.page.ConfirmPage;
      },

      title() {
        if (!this.pageData || !this.pageData.title)
          return "Политика обработки персональных данных";

        return this.pageData.title;
			},
			
			content() {
				if (!this.pageData || !this.pageData.describe) return null;
				return this.pageData.describe;
			}
    },
  };
</script>

<style lang="less">
  @import "../less/variables.less";

  main {
    &.policy .background-image {
      background-image: url("../assets/img/chartering_bg.jpg");
    }
  }

  .policyInfo {
    margin-bottom: 20px;

    .wrap {
      padding: 40px 20px;

      .up(@md;{padding: 60px;});

      .up(@lg;{padding: 70px;});
    }

    .up(@md;{margin-bottom: 40px;});

    .up(@lg;{margin-bottom: 80px;});
  }

  .policyList {
    font-weight: 300;

    &__item {
      margin-bottom: 40px;
      position: relative;

      p {
        margin-bottom: 15px;

        .up(@md;{margin-bottom: 20px;});
      }

      &::before {
        font-size: 20px;
        line-height: 28px;
        font-weight: 300;
        display: block;
        position: absolute;
        top: 0;
        left: 0;

        .up(@md;{font-size: 22px; line-height: 27px;});

        .up(@lg;{font-size: 35px; line-height: 45px;});
      }

      &:last-child {
        margin-bottom: 0;
      }

      .up(@md;{margin-bottom: 60px;});

      .up(@lg;{margin-bottom: 70px;});
    }

    h6 {
      color: @black;
      display: inline-block;
      margin-bottom: 20px;
      padding-left: 23px;
      font-size: 22px;
      line-height: 27px;

      .up(@md;{});

      .up(@lg;{padding-left: 35px; font-size: 35px; line-height: 45px;});
    }

    &-inner {
      padding-left: 15px;

      .policyList__item {
        padding-left: 25px;
        margin-bottom: 20px;

        &::before {
          font-size: inherit;
          line-height: inherit;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .up(@md;{padding-left: 45px; margin-bottom: 25px;});
      }
    }
  }
</style>
